export default __webpack_public_path__ + "static/media/4.21afaa98.svg";